module.exports = __webpack_public_path__ + "img/roll-1229.234c0b15.png";